export const ContactCSS = {
  contact: {
    padding: "20px",
    margin: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "64vh",
  },
  item: {
    display: "flex",
    justifyContent: "center",
  },
};
